// extracted by mini-css-extract-plugin
module.exports = {"gradient":"TableRow_gradient__1zhKI","table-width":"TableRow_table-width__1o6TB"};